import { HIERARCHY } from './actionTypes';
import { LocationInterface } from '../Interfaces/LocationInterface';
import { actionCreator } from './';
import { HierarchyInterface } from '../Interfaces/HierarchyInterface';

// TODO Remove, duplicate of locations
export const setLocationHierarchy = actionCreator<LocationInterface[]>(HIERARCHY.SET_LOCATION_HIERARCHY);

export const loadHierarchy = actionCreator<HierarchyInterface>(HIERARCHY.LOAD);
